import {
  StepProps,
  type StepMap,
} from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.types";
import {
  FooterContainer,
  FooterNextButton,
  FooterSkipButton,
  StepTitle,
  StyledStepTitleWrapper,
  WizardContentWrapper,
} from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.styles";
import { DropTargetStep } from "./DropTargetStep";
import { StepGroups } from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.config";
import { StepContentWithTabs } from "@/components/onboarding/components/WelcomeWizard/Tabs";
import { MDSTextWeight, MDSTextVariant, MDSText, MDSIconButton } from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";

const ObsidianStep: React.FC<StepProps> = ({
  onNavToStep,
  onSkip,
  handleTabSelect,
  onClose,
  context,
}) => (
  <WizardContentWrapper>
    <StyledStepTitleWrapper>
      <StepTitle>Import Notes</StepTitle>
      {context.wizardType === "import" && (
        <MDSIconButton iconKind={MdsIconKind.Exit} onClick={onClose} />
      )}
    </StyledStepTitleWrapper>
    <StepContentWithTabs
      selectedAppId={context?.selectedAppId || null}
      onAppSelect={handleTabSelect}
      tabConfig={StepGroups["IMPORT"].tabConfig}
    >
      <MDSText variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Regular}>
        Bring in your Obsidian notes so you can find them with Mem Search, Chat, and Copilot
      </MDSText>
      <DropTargetStep
        onDrop={() => {
          if (context.wizardType === "welcome") onNavToStep?.("download-apps");
          if (context.wizardType === "import") onClose?.();
        }}
      />
    </StepContentWithTabs>
    {context.wizardType === "welcome" && (
      <FooterContainer align="space-between">
        <FooterSkipButton onClick={onSkip}>Skip for now</FooterSkipButton>
        <FooterNextButton onClick={() => onNavToStep?.("download-apps")}>
          Next step
        </FooterNextButton>
      </FooterContainer>
    )}
  </WizardContentWrapper>
);

export const ObsidianStepsMap: StepMap = {
  "obsidian-1": {
    id: "obsidian-1",
    group: "import-cta",
    render: ({ onNavToStep, onSkip, handleTabSelect, onClose, context }) => (
      <ObsidianStep
        onNavToStep={onNavToStep}
        onSkip={onSkip}
        handleTabSelect={handleTabSelect}
        onClose={onClose}
        context={context}
      />
    ),
  },
};
